module.exports = __webpack_public_path__ + "assets/img/cloud7.01909070.webp";